<p-toast></p-toast>

<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Cargando ... </span>
</div>

<div class="card">

    <!-- GO BACK -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">

            <!-- GO BACK BUTTON-->
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>

            <!-- APPROVE BUTTON -->
            <button pButton pRipple type="button" label="{{translations.lbl_approve}}"
                [pTooltip]="translations.lbl_approve"
                [ngStyle]="{'background-color': '#960018', 'border-color': '#960018', 'color': 'white'}"
                *ngIf="orderId && purchOrdH?.status=='N'" class="p-button-raised p-button-danger  p-mr-2"
                (click)="approve()">
            </button>

            <!-- RETURN ORDER -->
            <button pButton pRipple label="Devolver Solicitud" icon="pi pi-chevron-left"
                *ngIf="orderId && purchOrdH?.status=='A'" class="p-button-warning p-mr-2"
                (click)="returnToNew()"></button>


            <!-- APPROVE TO INVENTORY -->
            <button pButton pRipple type="button" label="Aprobar para Inventario (FIII)"
                pTooltip="Aprobar para Inventario (FIII)"
                [ngStyle]="{'background-color': '#960018', 'border-color': '#960018', 'color': 'white'}"
                *ngIf="orderId && purchOrdH?.status=='A'" class="p-button-raised p-button-danger p-mr-2"
                (click)="approveToInvent()">
            </button>
        </ng-template>
    </p-toolbar>

    <!-- FORM CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-grid">

                    <!-- SELLER INPUT -->
                    <div class="p-col-12">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between ">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_vendor}}</span>
                            </div>

                            <ng-container class="p-col-12 p-md-8">
                                <span class="p-text-bold"> {{ selectedSupplier?.name || 'Sin Proveedor' }}
                                </span>
                            </ng-container>

                        </div>
                    </div>

                    <!-- DOCUMENT INPUT -->
                    <div class="p-col-12">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between ">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>Id Documento</span>
                            </div>

                            <ng-container class="p-col-12 p-md-8">
                                <span class="p-text-bold">{{orderId || 'Sin Identificador de documento'}}</span>
                            </ng-container>

                        </div>
                    </div>


                    <!-- DATE REQ INPUT -->
                    <div class="p-col-12">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between ">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>Fecha requerimiento</span>
                            </div>

                            <ng-container *ngIf="!(orderId && purchOrdH?.status !== 'N'); else showSpan">
                                <div class="p-col-12 p-md-8">
                                    <p-calendar id="dateSelectedId" [(ngModel)]="ordDate" [touchUI]="true"
                                        [disabled]="orderId && purchOrdH?.status != 'N'" [readonlyInput]="true"
                                        inputId="touchui" dateFormat="yy-mm-dd" class="p-fluid"></p-calendar>
                                </div>
                            </ng-container>

                            <ng-template class="p-col-12 p-md-8" #showSpan>
                                <span class="p-text-bold">{{ ordDate | date:'yyyy-MM-dd' }}</span>
                            </ng-template>
                        </div>
                    </div>


                    <!-- CURRENCY INPUT -->
                    <div class="p-col-12">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between ">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>Moneda</span>
                            </div>

                            <ng-container *ngIf="!(orderId && purchOrdH?.status !== 'N'); else showSpanCurrency">
                                <div class="p-col-12 p-md-8">
                                    <p-dropdown [options]="lstCurrency" [(ngModel)]="selectedCurrency"
                                        optionLabel="value" [disabled]="orderId && purchOrdH?.status!='N'"
                                        [showClear]="true" placeholder="Selecione moneda" class="p-fluid"></p-dropdown>
                                </div>
                            </ng-container>

                            <ng-template class="p-col-12 p-md-8" #showSpanCurrency>
                                <span class="p-text-bold">{{ selectedCurrency?.value}}</span>
                            </ng-template>
                        </div>
                    </div>


                    <!-- LANGUAJE INPUT -->
                    <div class="p-col-12">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between ">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_language}}</span>
                            </div>

                            <ng-container *ngIf="!(orderId); else showSpanLanguage">
                                <div class="p-col-12 p-md-8">
                                    <p-dropdown [options]="listLanguage" [(ngModel)]="selectedLanguage"
                                        optionLabel="value" [showClear]="true"
                                        placeholder="{{translations.lbl_language}}" (onChange)="loadData()"
                                        [disabled]="orderId" class="p-fluid"></p-dropdown>
                                </div>
                            </ng-container>

                            <ng-template class="p-col-12 p-md-8" #showSpanLanguage>
                                <span class="p-text-bold">{{ selectedLanguage?.value}}</span>
                            </ng-template>
                        </div>
                    </div>


                    <!-- FILTER INPUT -->
                    <div class="p-col-12">
                        <div class="p-formgrid p-grid p-ai-center p-jc-center  p-py-3">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>Filtrar</span>
                            </div>
                            <div class="p-col-12 p-md-8" style="text-align: center;">
                                <div *ngIf="purchOrdDtl" class="p-d-flex p-ai-left p-jc-around">
                                    <p-radioButton label="Mostrar todos los articulos" name="groupname" value="all"
                                        [(ngModel)]="filterVal" (ngModelChange)="handleShowRequired()"></p-radioButton>
                                    <p-radioButton label="Mostrar solo requeridos" name="groupname" value="only"
                                        [(ngModel)]="filterVal" (onClick)="handleShowRequired()"></p-radioButton>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </p-panel>
        </div>
    </div>



    <!-- MAIN TABLE -->
    <p-table [exportFilename]="tableName" *ngIf="purchOrdDtl" #dt [value]="purchOrdDtl" [columns]="[{ field: 'itemId', header: 'Id Articulo' },{ field: 'descri', header: 'Fecha Descripcion' },
                    { field: 'conv', header: 'Mult' },{ field: 'consumption', header: 'Consumo 1 año' },{ field: 'twentyPercent', header: '+20%' },
                    { field: 'subtotal', header: 'Subtotal' },{ field: 'onHand', header: 'Existencia' },
                    { field: 'budget', header: 'Presupuesto' },{ field: 'ordD.appQty', header: 'Cantidad Requer' },{ field: 'ordD.unitCost', header: 'Costo Unitario' },
                    { field: 'total', header: 'Total' }]" [rows]="20" [paginator]="true"
        [globalFilterFields]="['itemId','descri','conv','consumption','twentyPercent','subtotal','onHand','budget','ordD.appQty','ordD.unitCost','total']"
        [(selection)]="selectedOrderLst" selectionMode="multiple" [rowHover]="true" dataKey="itemId"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
        responsive="true" editMode="row">

        <!-- CAPTION -->
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-left p-jc-between">
                <!-- MAIN TITLE-->
                <h5 class="p-md-6">Orden Compra (Cotización), Detalle</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </span>
            </div>

            <span class="p-input-icon-left">

                <!-- DELETE BUTTON -->
                <button pButton pRipple icon="pi pi-trash" class="p-button-danger p-mr-2"
                    (click)="deleteselectedPurchOrdDtl()" [disabled]="purchOrdH && purchOrdH?.status!='N'"></button>

                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>

            </span>

        </ng-template>

        <!-- HEADER -->
        <ng-template pTemplate="header">
            <!-- Order -->
            <tr>
                <th pSortableColumn="itemId">Id Articulo <p-sortIcon field="itemId"></p-sortIcon></th>
                <th pSortableColumn="descri">Descripción<p-sortIcon field="descri"></p-sortIcon></th>
                <th pSortableColumn="conv">Mult <p-sortIcon field="conv"></p-sortIcon></th>
                <th pSortableColumn="consumption">Consumo (1 año) <p-sortIcon field="consumption"></p-sortIcon></th>
                <th pSortableColumn="twentyPercent">+20% <p-sortIcon field="twentyPercent"></p-sortIcon></th>
                <th pSortableColumn="subtotal">Subtotal <p-sortIcon field="subtotal"></p-sortIcon></th>
                <th pSortableColumn="ordD.appQty">Existencia <p-sortIcon field="ordD.appQty"></p-sortIcon></th>
                <th pSortableColumn="budget">Presupuesto <p-sortIcon field="budget"></p-sortIcon></th>
                <th pSortableColumn="onHand">Cant Requer <p-sortIcon field="onHand"></p-sortIcon></th>
                <th pSortableColumn="costoUnit">Costo Unitario <p-sortIcon field="costoUnit"></p-sortIcon></th>
                <th pSortableColumn="total">Total <p-sortIcon field="total"></p-sortIcon></th>
                <th></th>
            </tr>
            <!-- Filter -->
            <tr>
                <th>
                    <p-columnFilter type="text" field="itemId"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="descri"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="conv"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="consumption"></p-columnFilter>
                </th>

                <th>
                    <p-columnFilter type="text" field="twentyPercent"></p-columnFilter>
                </th>

                <th>
                    <p-columnFilter type="text" field="subtotal"></p-columnFilter>
                </th>

                <th>
                    <p-columnFilter type="text" field="onHand"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="budget"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="ordD.appQty"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="ordD.unitCost"></p-columnFilter>
                </th>

                <th>
                    <p-columnFilter type="text" field="total"></p-columnFilter>
                </th>
                <th> </th>
            </tr>

            <!-- TOTALES -->
            <tr>
                <th colspan="10">
                    Totales
                </th>
                <th>
                    {{'$'+sumRows('total').toFixed(2)}}
                </th>
                <th>

                </th>
            </tr>
        </ng-template>

        <!-- BODY -->
        <ng-template pTemplate="body" let-order let-editing="editing" let-ri="rowIndex">
            <tr *ngIf="order?.itemId == null">
                <td class="itemCat2" colspan="12">
                    {{ order?.descri ? order.descri : 'S/N' }}
                </td>
            </tr>

            <tr *ngIf="order?.itemId != null" [pSelectableRow]="order" [pEditableRow]="order">
                <td> {{ order?.itemId ?order.itemId : ' ' }}</td>
                <td style="white-space: normal; word-wrap: break-word;">
                    <mark
                        [ngStyle]="{ 'background-color': order?.itemColor != null ? order?.itemColor : 'transparent' }">
                        {{ order?.descri ? order.descri : 'S/N' }}
                    </mark>
                </td>
                <td> {{order.itemId? (order?.conv ? order.conv.toFixed(0) : '0'):' ' }}</td>
                <td> {{order.itemId? (order?.consumption ? order.consumption.toFixed(0) : '0'):' ' }}</td>
                <td> {{order.itemId? (order?.twentyPercent ? order.twentyPercent.toFixed(0) : '0'):' ' }}</td>
                <td> {{order.itemId? (order?.subtotal ? order.subtotal.toFixed(0) : '0'):' ' }}</td>
                <td> {{order.itemId? (order?.onHand ? order.onHand.toFixed(0) : '0'):' ' }}</td>
                <td> {{order.itemId? (order.budget ?order.budget.toFixed(0):'0'):' '}}</td>

                <td *ngIf="editing">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="order.ordD.appQty">
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{order.itemId? (order?.ordD?.appQty ? '$' + order?.ordD?.appQty.toFixed(2) : '0'):' '}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td *ngIf="!editing"> {{order.itemId? (order?.ordD?.appQty ?
                    order?.ordD?.appQty : '0'):' '}}</td>

                <td *ngIf="editing">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="order.ordD.unitCost">
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{order.itemId? (order?.ordD?.unitCost ? '$' + order?.ordD?.unitCost?.toFixed(2) : '0'):'
                            '}}
                        </ng-template>
                    </p-cellEditor>
                </td>

                <td *ngIf="!editing"> {{order.itemId? (order?.ordD?.unitCost ? '$' +
                    order?.ordD?.unitCost : '0'):' '}}</td>

                <td>{{order.itemId? (order?.total ? '$' + order?.total?.toFixed(2) : '0'):' ' }}</td>

                <td style="text-align:center">

                    <!-- EDIT BUTTON -->
                    <button pButton pRipple pInitEditableRow icon="pi pi-pencil"
                        class="p-button-rounded p-button-warning p-mr-2"
                        *ngIf="order.itemId && !editing  && (!orderId || orderId && purchOrdH.status=='N')"
                        (click)="onRowEditInit(order)"></button>

                    <!-- SAVE BUTTON -->
                    <button pButton pRipple pSaveEditableRow icon="pi pi-save" class="p-button-rounded p-button-success p-mr-2"
                        *ngIf="editing" (click)="saveUpdatePurchOrd(order)"></button>

                    <!-- CANCEL BUTTON -->
                    <button pButton pRipple pCancelEditableRow type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-mr-2" *ngIf="editing"
                        (click)="onRowEditCancel(order, ri)"></button>

                    <!-- DELETE BUTTON -->
                    <button pButton pRipple pCancelEditableRow type="button" icon="pi pi-trash"
                        class="p-button-rounded p-button-danger p-mr-2"
                        *ngIf="order.itemId && !editing && (!orderId || orderId && purchOrdH.status=='N')"
                        (click)="deletepurchOrdDtl(order)"></button>
                </td>
            </tr>

        </ng-template>

        <!-- SUMMARY -->
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                In total there are {{purchOrdDtl != null ? purchOrdDtl.length : 0 }} entries.
            </div>
        </ng-template>
    </p-table>


</div>

<!-- CONFIRM DIALOG -->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>